import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';

import styles from './CreateCourseHeader.module.scss';
import usePresenter from './CreateCourseHeader.presenter';
import getProps from './CreateCourseHeader.props';
import { CreateCourseHeaderCombinedProps } from './types';


const CreateCourseHeader: React.FC<CreateCourseHeaderCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
    button,
    divider,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.createCourseHeader;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.content, classes?.content)}>
        <div className={cx(styles.topContent, classes?.topContent)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}/>
        </div>
        <Divider
          className={cx(styles.divider, classes?.divider)}
          {...internalProps.divider}
          {...divider}/>
      </div>
    </div>
  );
};

export default CreateCourseHeader;

